import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SummarizeComponent } from './summarize/summarize.component';
import { AuthGuardService as AuthGuard } from './../../auth-guard.service';
const routes: Routes = [
   
  {
    path: 'summarization',
     component: SummarizeComponent, 
    canActivate: [AuthGuard], 
  }
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
     RouterModule.forChild(routes)
  ],
  exports:[RouterModule]
})
export class SummarizeRoutingModule { }
